import React from 'react'
import { ConfigGeneralContext } from './ConfigGeneralContext';
import { useConfigGeneral } from '../../hooks/useConfigGeneral';

export const ConfigGeneralProvider = ({children}) => {
    const{
        mode,
        getDataMode,
    } = useConfigGeneral();
    return (
        <ConfigGeneralContext.Provider value={{
            mode,
            getDataMode,
        }}
        >
          {children}
        </ConfigGeneralContext.Provider>
      );
}
